import LogRocket from 'logrocket';
import * as Sentry from '@sentry/react';
//import setupLogRocketReact from '@logrocket/sentry';

const logRocketAppId = process.env.REACT_APP_LOGROCKET_APPID;
//const sentryDSN = process.env.REACT_APP_SENTRY_DSN;

// Function to initialize LogRocket
const initLogRocket = () => {
  if (!logRocketAppId) {
    console.warn("LogRocket App ID is missing.");
    return;
  }

  if (process.env.REACT_APP_LOGROCKET_ENABLED === 'true') {

    LogRocket.init(`${logRocketAppId}`, {
        dom: {
          inputSanitizer: (inputValue) => inputValue.replace(/./g, '*') // Masks all input fields
        }
      });
  }

  if (LogRocket._isInitialized) {

    LogRocket.getSessionURL((sessionURL) => {
      Sentry.setContext('session', { sessionURL });
    });
  }
}

// Function to check Klaro consent and initialize LogRocket
export const checkAndInitializeLogRocket = () => {
  if (window.klaro) {
    try {
      const manager = window.klaro.getManager();
      if (manager.getConsent("logrocket")) {
        initLogRocket();
      } else {
      }
    } catch (error) {
      console.error("Error accessing Klaro manager:", error);
    }
  } 
};

window.checkAndInitializeLogRocket = checkAndInitializeLogRocket;

// Ensure LogRocket only initializes if consent is already granted
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(checkAndInitializeLogRocket, 1000);
});